module.exports = __webpack_public_path__ + "static/media/snake2.6a88eb0f.PNG";